import axiosIns from '@/api/axios';
import querystring from 'query-string';

export const GET_DATA_LIST = (body) => {
	return axiosIns.post(`/monitoring/gl_code`, body);
};

export const GET_VENDOR = (body) => {
	return axiosIns.get(`/vendor`);
};

export const GET_DATA_LIST_CONTRACT = (idBudgetTask) => {
	return axiosIns.get(`/actual/contract/list/${idBudgetTask}`);
};

export const ACTUAL_BEFORE = (body) => {
	return axiosIns.post(`/actual`, body);
};

export const SAVE_RELOCATE = (body) => {
	return axiosIns.post(`/plan/relocate`, body);
};

export const SAVE_RELOCATE_EXT = (body) => {
	return axiosIns.post(`/plan/relocate-eks-int`, body);
};

export const SAVE_ACTUAL_ITEM = (body) => {
	return axiosIns.post(`/actual-items`, body);
};

export const SEND_EMAIL_PO = (body) => {
	return axiosIns.post(`/send-email-by-po`, body);
};

export const CLOSE_PO = (id) => {
	return axiosIns.post(`/actual/closed/${id}`);
};

export const GET_ALL_MONITORING = (body) => {
	return axiosIns.get(`/monitoring-v2`);
};

export const GET_ALL_MONITORING_FILTER = (body) => {
	return axiosIns.get(`/monitoring-custom-dashboard?${body}`);
};
export const GET_ALL_MONITORING_FILTER_CUSTOME = (body) => {
	return axiosIns.get(`/monitoring-custom-dashboard-filter?${body}`);
};

export const GET_TOP_OPEX = (body) => {
	return axiosIns.get(`/get-max-opex`);
};

export const GET_TOP_CAPEX = (body) => {
	return axiosIns.get(`/get-max-capex`);
};

export const GET_TOP_OPEX_DASHBOARD = (body) => {
	return axiosIns.get(`/get-max-opex?${body}`);
};
export const GET_TOP_OPEX_DASHBOARD_FILTER = (body) => {
	return axiosIns.get(`/get-max-opex-filter?${body}`);
};

export const GET_TOP_CAPEX_DASHBOARD = (body) => {
	return axiosIns.get(`/get-max-capex?${body}`);
};
export const GET_TOP_CAPEX_DASHBOARD_FILTER = (body) => {
	return axiosIns.get(`/get-max-capex-filter?${body}`);
};

export const GET_REPORT = (type) => {
	if (type == 'Budget Plan') {
		return axiosIns.post(
			`/report-budget-plan`,
			{
				responseType: 'blob',
			},
			{
				responseType: 'arraybuffer',
				headers: {
					'Content-Type': 'application/octet-stream',
				},
			}
		);
	} else if (type == 'Actual Budget') {
		return axiosIns.post(
			`report-actual-expenses`,
			{
				responseType: 'blob',
			},
			{
				responseType: 'arraybuffer',
				headers: {
					'Content-Type': 'application/octet-stream',
				},
			}
		);
	} else if (type == 'Budget Relocation') {
		return axiosIns.post(
			`/report-relocate-plan`,
			{
				responseType: 'blob',
			},
			{
				responseType: 'arraybuffer',
				headers: {
					'Content-Type': 'application/octet-stream',
				},
			}
		);
	} else if (type == 'Budget Monitoring') {
		return axiosIns.post(
			`/report-budget-monitoring`,
			{
				responseType: 'blob',
			},
			{
				responseType: 'arraybuffer',
				headers: {
					'Content-Type': 'application/octet-stream',
				},
			}
		);
	}
};

export const GET_UCONTRACT_DEPARTMENTS = () => {
	return axiosIns.get(`/actual/contract/departments`);
};
